import { useApiPrivateRequest } from "../../../shared/hooks/useApi";
import { LlmHealthCheck } from "../models/LlmHealthCheck";

export const useGetLlmHealthChecks = () => {
  const {
    data: healthChecks,
    call,
    isLoading,
    isFailed,
  } = useApiPrivateRequest<LlmHealthCheck[]>((response) =>
    response.map((item: any) => new LlmHealthCheck(item)),
  );

  const getLlmHealthChecks = async (from?: Date, to?: Date) => {
    // Default to last hour if no dates provided
    const defaultTo = to || new Date();
    const defaultFrom = from || new Date(defaultTo.getTime() - 60 * 60 * 1000); // 1 hour ago

    const params = new URLSearchParams({
      from: defaultFrom.toISOString(),
      to: defaultTo.toISOString(),
    });

    await call(`/admin/llm/health?${params.toString()}`, "GET");
  };

  return {
    healthChecks,
    getLlmHealthChecks,
    isLoading,
    isFailed,
  };
};
